import styled from "styled-components";
import {borderColour, subduedTextColour} from "../../../style/styleConsts";

export const Header = styled.div`
    font-weight: bold;
    border-bottom: 1px solid ${borderColour};
    padding-bottom: 4px;
    margin-bottom: 10px;
`;

export const Title = styled.div`
    font-size: 12px;
    color: ${subduedTextColour};
`